import { useSelector } from 'react-redux';

import { useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { selectArticleHeadingVisible } from '../../../common/selectors/helpCenter';
import { selectHomepageContent } from '../../../common/selectors/homepage';
import { Page } from '../../../common/types';
import { renderModel } from '../../../util/renderModel';

const isLandingPage = renderModel.isLandingPage();

export function useSearchBarHidden(): boolean {
  const articleHeadingVisible = useSelector(selectArticleHeadingVisible);
  const currentPage = useCurrentPage();
  const { data: homepageContent, loading: homepageLoading } = useSelector(selectHomepageContent);
  const homepageHidden = currentPage === Page.Home && (homepageContent?.hideSearch || homepageLoading);

  return (
    isLandingPage ||
    articleHeadingVisible ||
    currentPage === Page.Chatbot ||
    currentPage === Page.RequestSuccessManagerForm ||
    homepageHidden
  );
}
